import { InputBase, withStyles } from '@material-ui/core';

export const BaseInput = withStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    // borderRadius: '2px',
    fontWeight: 'normal',
    fontSize: '16px',
    minHeight: '45px',
    background: '#FCFCFC',
    color: '#1B1A1A',
    border: '1px solid #e6e6e6',
  },
  focused: {
    borderColor: theme.palette.primary.main,
  },
  input: {
    height: '100% !important',
    padding: '8px 15px',
    boxSizing: 'border-box',
    '&::placeholder': {
      color: '#9EA8AB',
    },
  },
  error: {
    borderColor: theme.palette.error.main,
  },
  multiline: {
    padding: 0,
  },
}))(InputBase);
